import { useIntl } from '@capsicum/common';
import { Divider, Text } from '@capsicum/common-web';
import { type FanTokenBreakdownCardBreakdownProps } from '@capsicum/features/nc-wallet/shared';
import { useId } from 'react';
import styled from 'styled-components';

import { FanTokenBreakdownCardToken } from './FanTokenBreakdownCardToken';

export const FanTokenBreakdownCardBreakdown = ({ tokens }: FanTokenBreakdownCardBreakdownProps) => {
	const { $t } = useIntl();
	const sectionID = useId();

	return (
		<S.Wrapper aria-labelledby={sectionID}>
			<S.Content>
				<S.Header>
					<Text id={sectionID} variant="caption2">
						{$t('fanTokenBreakdownCard.description')}
					</Text>

					<S.StyledDivider orientation="horizontal" />
				</S.Header>

				<S.Tokens>
					{tokens.map(token => (
						<FanTokenBreakdownCardToken key={token.shortCode} {...token} />
					))}
				</S.Tokens>
			</S.Content>

			<Divider orientation="horizontal" />
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.small};
	`;

	export const Header = styled.div`
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: ${({ theme }) => theme.spacings.xxxsmall};
	`;

	export const Content = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;

	export const Tokens = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;

	export const StyledDivider = styled(Divider)`
		flex: 1;
	`;
}
